<button (click)="openCreate()" class="btn btn-primary-outline add-button">Add</button>
<h5 class="mb-4">Capabilities</h5>

@if (capabilities().length > 0) {
  <app-sortable-table [headers]="headers" class="table-striped">
    @for (item of capabilities(); track item.startDate) {
      <tr>
        <td>{{ item.types | enumArrayParse }}</td>
        <td>{{ item.startDate | dateParse | dateFormat: 'ddd, D MMM YYYY' }}</td>
        @if (canEditAtDate(item.startDate)) {
          <td>
            <i (click)="openUpdate(item)" class="fa fa-xs fa-pen pointer me-1"></i>
            <i (click)="openDelete(item)" class="fa fa-xs fa-trash pointer"></i>
          </td>
        } @else {
        <td></td>
      }
      </tr>
    }
  </app-sortable-table>
} @if (lastCapabilitiesAreNotEmpty()) {
  <div (click)="openCreateEmpty()" class="delete-capability-link ms-2">
    Delete capabilities starting from the selected week
  </div>
}